import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { RouterLinkSafeUrlPipe } from '@lib/shared/util';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ToastModule } from 'primeng/toast';
import { IncidentService } from '@lib/incident/data-access';
import { FeatureToggleService } from '@lib/feature-toggle/data-access';
import { FeatureToggleType } from '@lib/feature-toggle/models';
import { ToastMessageOptions } from 'primeng/api';
import { AuthService } from '@lib/auth/data-access';

@Component({
  selector: 'lib-notification-feature-incident-assignment-notification',
  standalone: true,
  imports: [
    RouterLinkSafeUrlPipe,
    RouterModule,
    ToastModule,
    AvatarModule,
    AvatarGroupModule
],
  templateUrl:
    './notification-incident-assignment-notification.component.html',
  styleUrl:
    './notification-incident-assignment-notification.component.scss',
})
export class NotificationIncidentAssignmentNotificationComponent {
    message = input.required<ToastMessageOptions>();
    
    // inject
    private router = inject(Router);
    public authService = inject(AuthService);
    private featureToggleService = inject(FeatureToggleService);
    private incidentService = inject(IncidentService);
    // public
    public isNotificationFeatureEnabled = computed(() => { return this.featureToggleService.tenantFeaturesComputedSignal().some(feature => feature.id === FeatureToggleType.Notifications && feature.isEnabled) })

    // private
    // ..

    navigateToAssignments(incidentReportId: number) {
      this.incidentService.setIsComingFromOutsideModule(true, 'assignments');
      this.router.navigateByUrl(`t/${this.authService.userPrincipalComputedSignal()?.currentTenantExternalId}/incidents/${incidentReportId}/assignments`);
    }
  
    navigateToIncident(incidentReportId: number) {
      this.router.navigateByUrl(`t/${this.authService.userPrincipalComputedSignal()?.currentTenantExternalId}/incidents/${incidentReportId}`);
    }
}
